module.exports = __webpack_public_path__ + "img/DK35521267.829348a6.png";